import { ScrollView, StyleSheet } from 'react-native';
import { Chip } from 'react-native-paper';

interface FilterOption {
  readonly label: string;
  readonly value: string;
}

interface FilterChipsProps {
  readonly options: readonly FilterOption[];
  readonly selected: string;
  readonly onSelect: (value: string) => void;
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  chip: {
    marginRight: 8,
  },
});

export const FilterChips = ({ options, selected, onSelect }: FilterChipsProps) => (
  <ScrollView
    contentContainerStyle={styles.container}
    horizontal
    showsHorizontalScrollIndicator={false}>
    {options.map((option) => (
      <Chip
        key={option.value}
        mode={option.value === selected ? 'flat' : 'outlined'}
        selected={option.value === selected}
        showSelectedCheck={false}
        style={styles.chip}
        onPress={() => onSelect(option.value)}>
        {option.label}
      </Chip>
    ))}
  </ScrollView>
);
